import { render, staticRenderFns } from "./OrCriteria.vue?vue&type=template&id=5ad3e060&scoped=true"
import script from "./OrCriteria.vue?vue&type=script&lang=js"
export * from "./OrCriteria.vue?vue&type=script&lang=js"
import style0 from "./OrCriteria.vue?vue&type=style&index=0&id=5ad3e060&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ad3e060",
  null
  
)

export default component.exports